// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-2hKZc";
var _3 = "documents-3sneB";
var _4 = "document-jBOJd";
var _5 = "format-g3bLW";
export { _1 as "__esModule", _2 as "wrapper", _3 as "documents", _4 as "document", _5 as "format" }
export default { "__esModule": _1, "wrapper": _2, "documents": _3, "document": _4, "format": _5 }
